// extracted by mini-css-extract-plugin
module.exports =  {"modalFooter":"modalFooter___Di5MO","button":"button___xTBlB","submitBtn":"submitBtn___5jEKe","clearBtn":"clearBtn___nNY8J"};